// Ortak müşteri/araç yazma yardımcıları (Faz 5 — G6, 2026-08-29).
// Amaç: Musteriler.js ve Dashboard.js'teki kopya "hızlı müşteri ekle" akışını
// TEK handler'a indirmek ve SIRA HATASINI bitirmek: tüm mükerrer kontroller
// müşteri dokümanı YAZILMADAN ÖNCE yapılır (yetim müşteri bug'ı biter).
// Hatalar YUTULMAZ: throw edilir; çağıran modal açık kalıp mesajı gösterir.

import { db } from '../firebase';
import { collection, addDoc, query, where, getDocs, serverTimestamp } from 'firebase/firestore';

// Telefonla mevcut müşteri arar; bulursa {id, ...data}, yoksa null.
export const telefonlaMusteriBul = async (telefon) => {
    if (!telefon) return null;
    const snap = await getDocs(query(collection(db, 'customers'), where('telefon', '==', telefon)));
    return snap.empty ? null : { id: snap.docs[0].id, ...snap.docs[0].data() };
};

// Plakayla mevcut araç arar; bulursa {id, ...data}, yoksa null.
export const plakaylaAracBul = async (plaka) => {
    if (!plaka) return null;
    const snap = await getDocs(query(collection(db, 'vehicles'), where('plaka', '==', plaka)));
    return snap.empty ? null : { id: snap.docs[0].id, ...snap.docs[0].data() };
};

/**
 * Hızlı müşteri (+ opsiyonel araç) ekleme — ön görüşme paritesinde (G6).
 * customerData: { adSoyad, telefon, email, adres }
 * vehicleInfo (opsiyonel): { plaka, plakaBekleniyor, marka, model, yil, renk }
 * SIRA: telefon kontrolü → plaka kontrolü → müşteri yaz → araç yaz.
 * Yeni yazımlar eklenmeTarihi + createdAt İKİSİNİ de alır (okuma a||b — orderBy tuzağı yok).
 */
export const hizliMusteriEkle = async (customerData, vehicleInfo) => {
    // 1) Telefon mükerrer kontrolü — müşteri YAZILMADAN önce.
    const mevcutMusteri = await telefonlaMusteriBul(customerData.telefon);
    if (mevcutMusteri) {
        throw new Error(`Bu telefon numarası zaten kayıtlı: ${mevcutMusteri.adSoyad}. Yeni kayıt açmak yerine mevcut müşteriyi kullanın.`);
    }

    // 2) Plaka mükerrer kontrolü — müşteri YAZILMADAN önce (yetim müşteri bug'ı biter).
    const plakaFinal = vehicleInfo?.plakaBekleniyor ? '' : (vehicleInfo?.plaka || '');
    if (vehicleInfo && plakaFinal) {
        const mevcutArac = await plakaylaAracBul(plakaFinal);
        if (mevcutArac) {
            throw new Error(`${plakaFinal} plakası zaten kayıtlı (sahibi: ${mevcutArac.musteriAdSoyad || 'bilinmiyor'}). Müşteri OLUŞTURULMADI.`);
        }
    }

    // 3) Müşteri yaz.
    const newCustomerRef = await addDoc(collection(db, 'customers'), {
        ...customerData,
        eklenmeTarihi: serverTimestamp(),
        createdAt: serverTimestamp()
    });

    // 4) Araç yaz (varsa) — musteriAdSoyad + plaka:'' garantisi.
    if (vehicleInfo) {
        await addDoc(collection(db, 'vehicles'), {
            plaka: plakaFinal,
            plakaBekleniyor: Boolean(vehicleInfo.plakaBekleniyor),
            marka: vehicleInfo.marka || '',
            model: vehicleInfo.model || '',
            yil: vehicleInfo.yil || '',
            renk: vehicleInfo.renk || '',
            musteriId: newCustomerRef.id,
            musteriAdSoyad: customerData.adSoyad || '',
            eklenmeTarihi: serverTimestamp(),
            createdAt: serverTimestamp()
        });
    }

    return newCustomerRef.id;
};
